import React, { useState } from 'react';
import { Bell, Grid, LogOut, User, Settings, HelpCircle, Cloud, CloudOff, Check } from 'lucide-react';
import { BottomNav } from '../ui/BottomNav';
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface OfficerLayoutProps {
  children: React.ReactNode;
  title?: string;
}
export function OfficerLayout({
  children,
  title
}: OfficerLayoutProps) {
  const navigate = useNavigate();
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(true);
  const handleLogout = () => {
    navigate('/portal');
  };
  const notifications = [{
    id: 1,
    title: 'Tugas Baru',
    message: 'Anda mendapat tugas sosialisasi baru di RW 05',
    time: '10 menit lalu',
    read: false
  }, {
    id: 2,
    title: 'Laporan Disetujui',
    message: 'Laporan #RPT-892 telah disetujui admin',
    time: '1 jam lalu',
    read: false
  }, {
    id: 3,
    title: 'Pengingat',
    message: 'Deadline program HPSN besok',
    time: '5 jam lalu',
    read: true
  }];
  return <div className="min-h-screen bg-gray-50 pb-20 font-sans text-gray-900" data-id="element-224">
      {/* Top Bar */}
      <header className="bg-white border-b sticky top-0 z-30 px-4 h-16 flex items-center justify-between shadow-sm" data-id="element-225">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => setIsProfileOpen(true)} data-id="element-226">
          <div className="h-9 w-9 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold text-sm relative" data-id="element-227">
            BS
            <div className={`absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full border-2 border-white ${isOnline ? 'bg-green-500' : 'bg-gray-400'}`} data-id="element-228"></div>
          </div>
          <div className="flex flex-col" data-id="element-229">
            <span className="text-sm font-semibold text-gray-900 leading-none" data-id="element-230">
              Budi Santoso
            </span>
            <span className="text-xs text-gray-500" data-id="element-231">Kota Bandung</span>
          </div>
        </div>

        <div className="flex items-center gap-2" data-id="element-232">
          <div className="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors cursor-pointer" onClick={() => setIsOnline(!isOnline)} title={isOnline ? 'Online - Data tersinkronisasi' : 'Offline - Data tersimpan lokal'} data-id="element-233">
            {isOnline ? <Cloud className="h-5 w-5 text-green-600" data-id="element-234" /> : <CloudOff className="h-5 w-5 text-gray-400" data-id="element-235" />}
          </div>

          <button className="p-2 text-gray-500 hover:bg-gray-100 hover:text-primary-600 rounded-full relative transition-colors" onClick={() => setIsNotificationOpen(true)} data-id="element-236">
            <Bell className="h-5 w-5" data-id="element-237" />
            <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full border-2 border-white" data-id="element-238"></span>
          </button>
        </div>
      </header>

      {/* Offline Banner */}
      {!isOnline && <div className="bg-gray-800 text-white text-xs py-1.5 px-4 text-center animate-in slide-in-from-top-0" data-id="element-239">
          Mode Offline Aktif. Data akan disinkronkan saat online.
        </div>}

      {/* Main Content */}
      <main className="container mx-auto px-4 py-6 max-w-xl animate-in fade-in duration-300" data-id="element-240">
        {title && <h1 className="text-xl font-bold text-gray-900 mb-6" data-id="element-241">{title}</h1>}
        {children}
      </main>

      {/* Bottom Navigation */}
      <BottomNav data-id="element-242" />

      {/* Notification Modal */}
      <Modal isOpen={isNotificationOpen} onClose={() => setIsNotificationOpen(false)} title="Notifikasi" size="sm" className="mb-0 rounded-b-none sm:rounded-b-lg sm:mb-auto fixed bottom-0 sm:relative w-full sm:w-auto" data-id="element-243">
        <div className="space-y-4 max-h-[60vh] overflow-y-auto" data-id="element-244">
          {notifications.map(notif => <div key={notif.id} className={`p-3 rounded-lg border ${notif.read ? 'bg-white' : 'bg-blue-50 border-blue-100'}`} data-id="element-245">
              <div className="flex justify-between items-start mb-1" data-id="element-246">
                <h4 className={`text-sm font-medium ${notif.read ? 'text-gray-900' : 'text-blue-800'}`} data-id="element-247">
                  {notif.title}
                </h4>
                <span className="text-xs text-gray-500" data-id="element-248">{notif.time}</span>
              </div>
              <p className="text-xs text-gray-600" data-id="element-249">{notif.message}</p>
            </div>)}
          <Button variant="ghost" className="w-full text-xs text-primary-600" data-id="element-250">
            Tandai Semua Dibaca
          </Button>
        </div>
      </Modal>

      {/* Profile Modal */}
      <Modal isOpen={isProfileOpen} onClose={() => setIsProfileOpen(false)} title="Profil Saya" size="sm" className="mb-0 rounded-b-none sm:rounded-b-lg sm:mb-auto fixed bottom-0 sm:relative w-full sm:w-auto" data-id="element-251">
        <div className="space-y-6" data-id="element-252">
          <div className="flex items-center gap-4" data-id="element-253">
            <div className="h-16 w-16 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold text-2xl" data-id="element-254">
              BS
            </div>
            <div data-id="element-255">
              <h3 className="font-bold text-lg text-gray-900" data-id="element-256">Budi Santoso</h3>
              <p className="text-sm text-gray-500" data-id="element-257">
                NIP. 19850101 201001 1 001
              </p>
              <Badge variant="success" className="mt-1" data-id="element-258">
                Officer Level 3
              </Badge>
            </div>
          </div>

          <div className="space-y-2" data-id="element-259">
            <button className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition-colors text-left" data-id="element-260">
              <User className="h-5 w-5 text-gray-400" data-id="element-261" />
              <span className="text-sm font-medium text-gray-700" data-id="element-262">
                Edit Profil
              </span>
            </button>
            <button className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition-colors text-left" data-id="element-263">
              <Settings className="h-5 w-5 text-gray-400" data-id="element-264" />
              <span className="text-sm font-medium text-gray-700" data-id="element-265">
                Pengaturan Aplikasi
              </span>
            </button>
            <button className="w-full flex items-center gap-3 p-3 hover:bg-gray-50 rounded-lg transition-colors text-left" data-id="element-266">
              <HelpCircle className="h-5 w-5 text-gray-400" data-id="element-267" />
              <span className="text-sm font-medium text-gray-700" data-id="element-268">
                Bantuan & FAQ
              </span>
            </button>
            <button onClick={handleLogout} className="w-full flex items-center gap-3 p-3 hover:bg-red-50 rounded-lg transition-colors text-left text-red-600" data-id="element-269">
              <LogOut className="h-5 w-5" data-id="element-270" />
              <span className="text-sm font-medium" data-id="element-271">Keluar</span>
            </button>
          </div>

          <div className="text-center text-xs text-gray-400 pt-4 border-t" data-id="element-272">
            Versi Aplikasi 2.1.0 (Build 452)
          </div>
        </div>
      </Modal>
    </div>;
}